import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface FleetPulseSummary {
  live: number;
  stale: number;
  offline: number;
  never: number;
}

export interface ProblemProperty {
  id: string;
  name: string;
  org_name: string;
  poll_status: 'stale' | 'offline' | 'never' | 'unknown';
  last_telemetry_at: string | null;
  minutes_stale: number | null;
}

export interface FleetPulseData {
  totalProperties: number;
  summary: FleetPulseSummary;
  problemProperties: ProblemProperty[];
}

async function fetchFleetPulse(): Promise<FleetPulseData> {
  const { data, error } = await supabase.rpc('admin_fleet_pulse');
  if (error) throw error;

  const d = data as { total_properties: number; summary: FleetPulseSummary; problem_properties: ProblemProperty[] | null };
  return {
    totalProperties: d.total_properties,
    summary: d.summary,
    problemProperties: d.problem_properties ?? [],
  };
}

export function useAdminFleetPulse(enabled: boolean, refetchInterval: number | false) {
  return useQuery({
    queryKey: ['admin-fleet-pulse'],
    queryFn: fetchFleetPulse,
    enabled,
    refetchInterval,
  });
}
